/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import PropTypes from 'prop-types';

export default function ReturnTrainSection({ url, title }) {
  return (
    <a href={url} className="viewAlso makeFlex column blackText">
      <p className=" viewAlsoText">View Also</p>
      <p className="viewAlsoTitle latoBlack">{title}</p>
    </a>
  );
}

ReturnTrainSection.propTypes = {
  url: PropTypes.string.isRequired,
  fromCity: PropTypes.string.isRequired,
  toCity: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired
};
